import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/compania`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const fetchCompanias = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);
  let res = await fetch(readUrl(`?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};
